import { usePurchaseComponents } from "@contexts/PurchaseComponentsContext";
import type { AxiosInstance } from "axios";

import { useQuery } from "@tanstack/react-query";

import type { BoosterCalloutBannerResponse } from "./types";

const BOOSTER_CALLOUT_BANNER_PATH = "/v1/purchase/products/booster/callout-banner";
const BOOSTER_CALLOUT_BANNER_QUERY_KEY = "booster-callout-banner";

const fetchBoosterCalloutBanner = async (apiClient: AxiosInstance): Promise<BoosterCalloutBannerResponse> => {
  const { data } = await apiClient.get<BoosterCalloutBannerResponse>(BOOSTER_CALLOUT_BANNER_PATH);

  return data;
};

const getBoosterCalloutBannerQuery = (apiClient: AxiosInstance, enabled = true) => ({
  queryKey: [BOOSTER_CALLOUT_BANNER_QUERY_KEY, apiClient, enabled],
  queryFn: () => fetchBoosterCalloutBanner(apiClient),
  enabled,
});

/** Fetches booster eligibility for the current member. */
export const useBoosterCalloutBanner = (enabled = true) => {
  const { apiClient } = usePurchaseComponents();

  return useQuery(getBoosterCalloutBannerQuery(apiClient, enabled));
};
